module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qback5-c1251f1a6bb5ac0e49edb3c8aafb26ce.jpg";